import React from 'react'
import PropTypes from 'prop-types'
import './UserInfo.css'

const Persistence = ({label, onClick}) => {
  return (
    <div  className='up-ui-con' >
      <label className='up-ui-la up-ui-la2'>{label}</label>
      <button className='up-ui-bu' onClick={onClick}>Nastavit</button>
    </div>
  )
}

Persistence.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func
}

export default Persistence



// WEBPACK FOOTER //
// ./src/components/User/Persistence.js